<template lang="pug">
  #MyCustomer
    appHeader(
      :hasBackTool="true",
      :targetRouterName="route"
      :title="'顧客通訊錄'"
      :headerType="'logo'"
    )
    router-view
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSaFooter from '@/components/partials/AppSaFooter.vue';
import { SA_ITEMS_LIST_INDEX } from '@/router/sa/items-list';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'MyCustomerComponent',
  components: {
    appHeader,
    appSaFooter
  },
  data() {
    return {
      route: SA_ITEMS_LIST_INDEX
    };
  }
};
</script>
